/**
 * Portal Manta · FatoresQualLotePage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, S, fmtNum, sumBy, sigKey, fmtBRL, OBRAS_ROD } from '../../globals.js';
import { CONSOL_FIN } from '../../data/consol-fin.js';
import { TDl } from '../../app-globals.js';

const FatoresQualLotePage = memo(function FatoresQualLotePage_Inner({lote}){
  const sig = sigKey(lote);
  const cf = CONSOL_FIN[sig]||{};
  const od = OBRAS_ROD[sig]||{};
  const ext = parseFloat((lote.extensao||'').replace(/[^\d,.]/g,'').replace(',','.'))||0;
  const totSicro = Object.values(cf).reduce((s,arr)=>s+sumBy(arr,'v'),0);
  const corLote = sig==='3'?V.gn:(sig==='4'?V.bl:V.or);
  const dupKm = sumBy(od.duplicacoes||[],'km')+sumBy(od.contornos||[],'km');
  const fxKm = sumBy(od.faixas||[],'km');
  const margKm = sumBy(od.marginais||[],'km');
  const cicKm = sumBy(od.ciclovias||[],'km');
  const oaeN = sumBy(od.oaes||[],'n');
  const passN = sumBy(od.passarelas||[],'n');
  const interN = sumBy(od.diamantes||[],'n')+sumBy(od.trombetas||[],'n')+sumBy(od.parclos||[],'n')+sumBy(od.rotatorias||[],'n');
  const nRods = (od.sistema||[]).length;
  const pavSicro = sumBy(cf['PAVIMENTACAO']||[],'v');
  const terSicro = sumBy(cf['TERRAPLENOS E CONTENCOES']||[],'v');
  const drnSicro = sumBy(cf['DRENAGEM']||[],'v');
  const oaeSicro = sumBy(cf['OAES']||[],'v');
  const sinSicro = sumBy(cf['SINALIZACAO']||[],'v');
  const iluSicro = sumBy(cf['ILUMINACAO']||[],'v');
  const indicadores = [
    {l:'Extensão', v:fmtNum(ext,1)+' km'},
    {l:'Nº rodovias', v:nRods},
    {l:'CAPEX', v:'R$ '+fmtNum(lote.capex_total_b||0,2)+' bi'},
    {l:'TIR', v:((lote.tir||0)*100).toFixed(2)+'%'},
    {l:'Custo SICRO', v:fmtBRL(totSicro,0)},
    {l:'R$ médio/km', v:fmtBRL(ext?totSicro/ext:0,0)+'/km'},
    {sep:'INTENSIDADE DE OBRAS DE AMPLIAÇÃO'},
    {l:'Duplicação', v:fmtNum(dupKm,1)+' km · '+(ext?dupKm/ext*100:0).toFixed(1)+'% do trecho'},
    {l:'Faixas adicionais', v:fmtNum(fxKm,1)+' km'},
    {l:'Marginais', v:fmtNum(margKm,1)+' km'},
    {l:'Ciclovias', v:fmtNum(cicKm,1)+' km'},
    {sep:'PONTOS NOTÁVEIS'},
    {l:'OAEs', v:oaeN+' un · '+(ext?oaeN/ext:0).toFixed(2)+'/km'},
    {l:'Passarelas', v:passN+' un'},
    {l:'Interseções (todas)', v:interN+' un'},
    {sep:'COMPOSIÇÃO DO CUSTO SICRO'},
    {l:'% Pavimentação', v:fmtBRL(pavSicro,0)+' ('+(totSicro?pavSicro/totSicro*100:0).toFixed(1)+'%)'},
    {l:'% Terraplenos & Contenções', v:fmtBRL(terSicro,0)+' ('+(totSicro?terSicro/totSicro*100:0).toFixed(1)+'%)'},
    {l:'% Drenagem', v:fmtBRL(drnSicro,0)+' ('+(totSicro?drnSicro/totSicro*100:0).toFixed(1)+'%)'},
    {l:'% OAEs', v:fmtBRL(oaeSicro,0)+' ('+(totSicro?oaeSicro/totSicro*100:0).toFixed(1)+'%)'},
    {l:'% Sinalização', v:fmtBRL(sinSicro,0)+' ('+(totSicro?sinSicro/totSicro*100:0).toFixed(1)+'%)'},
    {l:'% Iluminação', v:fmtBRL(iluSicro,0)+' ('+(totSicro?iluSicro/totSicro*100:0).toFixed(1)+'%)'},
  ];
  return(<div style={S.page}>
    <div style={S.h1}>Fatores Qualitativos × Orçamento · {lote.nome}</div>
    <div style={S.sub}>
      KPIs derivados do PER + OBRAS_ROD + CONSOL_FIN para o lote selecionado.
    </div>
    <div style={{...S.card,overflow:'hidden'}}>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:11}}>
        <tbody>
          {indicadores.map((ind,i)=>{
            if(ind.sep) return(<tr key={'s'+i}><td colSpan={2} style={{padding:'10px 12px 4px',fontSize:10,fontWeight:700,letterSpacing:.5,color:V.gr,background:V.g0,borderTop:'2px solid '+V.b1}}>{ind.sep}</td></tr>);
            return(<tr key={i} style={S.trLine}>
              <td style={{...TDl,fontWeight:600,width:'40%'}}>{ind.l}</td>
              <td style={{...TDl,fontWeight:700,color:V.br}}>{ind.v}</td>
            </tr>);
          })}
        </tbody>
      </table>
    </div>
  </div>);
});

export { FatoresQualLotePage };
export default FatoresQualLotePage;
